import {useTranslationWithKeys} from "../../../../hooks/useTranslationWithKeys";
import {Select, SelectContent, SelectItem, SelectTrigger, SelectValue} from "../../../basic/select";

interface QuantitySelectorProps {
    quantity: number;
    onChange: (quantity: number) => void;
    label?: string;
}

export function QuantitySelector({quantity, onChange, label}: QuantitySelectorProps) {
    const {t} = useTranslationWithKeys();
    const quantities = [1, 2, 3, 4, 5];

    return (
        <div className="space-y-2 mb-6">
            {label && <p className="text-sm font-medium">{label}</p>}
            <Select value={quantity.toString()} onValueChange={(value) => onChange(parseInt(value))}>
                <SelectTrigger>
                    <SelectValue placeholder={t('pricing.quantity')}/>
                </SelectTrigger>
                <SelectContent>
                    {quantities.map((q) => (
                        <SelectItem key={q} value={q.toString()}>
                            {t('pricing.quantityOf', {count: q})}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>
    );
}
